import { FC, useEffect, useState } from "react";

import { REVIEWS_VALUES } from "./constants";
import ReviewItem from "./ReviewItem";
import { Button } from "../UI/Buttons/Button";
import useIsMobile from "@/custom_hooks/isMobile";

interface ReviewsListProps {
  initialVisibleNumberForDekstop?: number;
}

const ReviewsList: FC<ReviewsListProps> = ({
  initialVisibleNumberForDekstop = 1,
}) => {
  const isMobile = useIsMobile();
  const [visibleReviewCardsCount, setVisibleReviewCardsCount] = useState(
    initialVisibleNumberForDekstop,
  );
  const handleLoadMore = () => {
    setVisibleReviewCardsCount((prevCount) => prevCount + 3);
  };

  useEffect(() => {
    if (isMobile == true) {
      setVisibleReviewCardsCount(3);
    }
  }, [isMobile]);

  return (
    <>
      <section className="grid w-full gap-6 md:grid-cols-3">
        {REVIEWS_VALUES.slice(0, visibleReviewCardsCount).map(
          ({ id, comment, author, authorTitle, image }) => (
            <ReviewItem
              key={id}
              comment={comment}
              author={author}
              authorTitle={authorTitle}
              image={image}
            />
          ),
        )}
      </section>

      {visibleReviewCardsCount < REVIEWS_VALUES.length && (
        <div className="mt-8 flex w-full justify-center">
          <Button onClick={handleLoadMore} className="">
            Žiūrėti daugiau
          </Button>
        </div>
      )}
    </>
  );
};

export default ReviewsList;
